import { createContext, useContext } from 'react';

import { ConfiningBillingDelinquencyTier } from '~constants/billing/delinquency';

export interface BillingConfinementValue {
	tier: ConfiningBillingDelinquencyTier;
	reopen: () => void;
}

/** Present only while the Owner is confined to billing; null means nothing is locked. */
export const BillingConfinementContext = createContext<BillingConfinementValue | null>(
	null,
);

export const useBillingConfinement = (): BillingConfinementValue | null =>
	useContext(BillingConfinementContext);
